import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogOut, Home } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const YG_LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_bright-installations-1/artifacts/poi36fgm_younggunslighting%20logo.png";

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const doLogout = async () => {
    await logout();
    nav("/admin/login", { replace: true });
  };

  const isActive = (path) => loc.pathname === path || (path !== "/admin" && loc.pathname.startsWith(path));

  return (
    <div className="min-h-screen bg-[#05070A] text-white">
      <header className="sticky top-0 z-40 nav-glass border-b border-white/10">
        <div className="container-x py-3 flex items-center justify-between gap-6">
          <div className="flex items-center gap-6">
            <Link to="/admin" className="flex items-center gap-3">
              <img src={YG_LOGO} alt="Young Guns" className="h-14 md:h-16 w-auto object-contain drop-shadow-[0_0_18px_rgba(0,229,255,0.35)]" />
            </Link>
            <div className="hidden md:block h-8 w-px bg-white/10" />
            <div className="font-mono-accent text-[10px] tracking-[0.35em] uppercase text-[color:var(--primary)] hidden md:block">
              Admin Dashboard
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/admin"
              data-testid="admin-nav-quotes"
              className={`font-mono-accent text-[11px] tracking-[0.25em] uppercase transition-colors ${isActive("/admin") && !loc.pathname.startsWith("/admin/consultations") && !loc.pathname.startsWith("/admin/estimates") ? "text-[color:var(--primary)]" : "text-white/70 hover:text-white"}`}
            >
              Quotes
            </Link>
            <Link
              to="/admin/consultations"
              data-testid="admin-nav-consultations"
              className={`font-mono-accent text-[11px] tracking-[0.25em] uppercase transition-colors ${loc.pathname.startsWith("/admin/consultations") ? "text-[color:var(--primary)]" : "text-white/70 hover:text-white"}`}
            >
              Consultations
            </Link>
          </nav>

          <div className="flex items-center gap-3">
            {user && user.email && (
              <div className="hidden md:block text-right">
                <div className="font-mono-accent text-[10px] tracking-[0.25em] uppercase text-white/40">Signed in</div>
                <div className="text-sm text-white truncate max-w-[220px]">{user.email}</div>
              </div>
            )}
            <Link
              to="/"
              className="hidden md:inline-flex items-center gap-2 px-3 py-2 border border-white/10 text-white/70 hover:text-white hover:border-white/30 font-mono-accent text-[10px] tracking-[0.25em] uppercase"
            >
              <Home size={12} /> Site
            </Link>
            <button
              onClick={doLogout}
              data-testid="admin-logout"
              className="inline-flex items-center gap-2 px-3 py-2 border border-white/10 text-white/70 hover:text-[color:var(--primary)] hover:border-[color:var(--primary)]/60 font-mono-accent text-[10px] tracking-[0.25em] uppercase"
            >
              <LogOut size={12} /> Logout
            </button>
          </div>
        </div>
      </header>
      <main className="container-x py-10 md:py-14">
        {children}
      </main>
    </div>
  );
}
